import { useEffect, useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";

import * as Regex from 'utils/validations';
import { DataContext } from 'providers/data';
import { ParamsPageWebView } from 'utils/typeServices';

import { Typography, Box } from '@mui/material';

import Modals from 'components/views/Modals';
import Input from 'components/views/form/Input';
import ParseWebView from 'components/views/ParseWebView';
import PhoneCopyWebView from 'components/views/PhoneCopyWebView';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';

import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { ReactComponent as IcChangeOfOwnership } from 'assets/icons/ic-change-of-ownership-green.svg';

import { LinkExtermal } from '../styles';

const ChangeOfOwnership = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const { selectedCar, dataCreateChangeSolicitation, dataPostCancelChangeOwnerSolicitation, dataGetChangeSolicitation, handlePostCreateChangeSolicitation, handlePostCancelChangeOwnerSolicitation, handleGetChangeSolicitation } = useContext(DataContext);
    const { register, watch, formState: { errors }, handleSubmit } = useForm<{ name: string; phone: string }>();

    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [disabledBtn, setDisabledBtn] = useState(true);

    const [showModalExistActiveChanges, setShowModalExistActiveChanges] = useState(false);

    const name = watch('name');
    const phone = watch('phone');

    const handlePlaceholderPhone = (typePhone: string) => {
        const numberPhone = typePhone?.replace(/[^0-9]/g, '');

        if (numberPhone?.length > 3 && numberPhone[2] === '9') {
            return '(99) 99999-9999';
        } else {
            return '(99) 9999-9999';
        }
    }

    const handlePostCreateChangeSolicitationState = async () => {
        setIsLoading(true);
        if (selectedCar) {
            handleGetChangeSolicitation({
                body: {
                    cD_PESSOA: selectedCar?.CD_PESSOA,
                    cD_PEDIDO: selectedCar?.CD_PEDIDO,
                    nR_PLATAFORMA: selectedCar?.NR_PLATAFORMA
                }
            });
        }
    }

    const handleContinueWithActiveOccurrence = async () => {
        if (!selectedCar) {
            return;
        }

        setIsLoading(true);

        handlePostCancelChangeOwnerSolicitation({
            cD_PESSOA: selectedCar.CD_PESSOA,
            cD_PEDIDO: selectedCar.CD_PEDIDO,
            nR_PLATAFORMA: selectedCar.NR_PLATAFORMA
        });
    }

    useEffect(() => {
        if (name && name?.length > 0 && phone?.match(Regex.phone)) {
            setDisabledBtn(false);
        } else {
            setDisabledBtn(true);
        }
    }, [name, phone]);

    useEffect(() => {
        if (dataGetChangeSolicitation !== undefined) {
            setIsLoading(false);

            if (dataGetChangeSolicitation === false) {
                if (selectedCar) {
                    handlePostCreateChangeSolicitation({
                        body: {
                            cD_PESSOA: selectedCar.CD_PESSOA,
                            cD_PEDIDO: selectedCar.CD_PEDIDO,
                            nR_PLATAFORMA: selectedCar.NR_PLATAFORMA,
                            nM_PESSOA: name,
                            nR_TELEFONE_CONTATO: phone
                        }
                    });
                }
            }
            else if (dataGetChangeSolicitation && typeof dataGetChangeSolicitation === 'object') {
                setShowModalExistActiveChanges(true);
            }
        }

    }, [dataGetChangeSolicitation]);

    useEffect(() => {
        if (dataCreateChangeSolicitation !== undefined) {
            setIsLoading(false);

            if (dataCreateChangeSolicitation === false) {
                setShowModal(false);
            } else {
                setShowModal(true);
            }
        }

    }, [dataCreateChangeSolicitation]);

    useEffect(() => {
        if (dataPostCancelChangeOwnerSolicitation !== undefined) {
            if (dataPostCancelChangeOwnerSolicitation) {
                setShowModalExistActiveChanges(false);
                handlePostCreateChangeSolicitationState();
            } else {
                setIsLoading(false);
            }
        }
    }, [dataPostCancelChangeOwnerSolicitation]);

    return (
        <ParseWebView title='Troca de titularidade' link={isWebView ? '/wb/central-de-trocas' : '/central-de-trocas'} isWebView={isWebView} typePage='subpage'>
            <Box sx={{ maxWidth: '37.8rem', margin: '0 auto' }}>
                <Box sx={{ paddingBottom: '2.56rem', textAlign: 'center' }}>
                    <IcChangeOfOwnership />
                    <Typography sx={{ fontSize: '1.25rem', lineHeight: '24px' }}>
                        Olá, para a Troca de Titularidade <strong>precisamos de sua autorização,</strong><br />
                        para que nossa Central tente o contato com o novo titular.
                    </Typography>
                </Box>

                <Typography sx={{ fontSize: '1.125rem', fontWeight: 600, paddingBottom: '1.375rem' }}>
                    Dados do novo titular:
                </Typography>
                <Box component="form" sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '60% 39%' }, gap: '.75rem', marginBottom: '4.125rem' }} onSubmit={handleSubmit(handlePostCreateChangeSolicitationState)}>
                    <Box sx={{ 'button': { width: '100%', height: '2.5rem', display: { xs: 'none', md: 'flex' } } }}>
                        <Input
                            name='name'
                            label='Nome completo'
                            placeholder='Nome'
                            type='text'
                            error={errors.name}
                            textError="Insira o nome e sobrenome"
                            register={{ ...register("name", { pattern: Regex.name }) }}
                        />
                        <ButtonRectangle type="submit" name="REGISTRAR AUTORIZAÇÃO" loadingBtn={isLoading} disabled={disabledBtn} />
                    </Box>
                    <Input
                        name='phone'
                        label='Celular'
                        placeholder={handlePlaceholderPhone(phone)}
                        maskHolder={handlePlaceholderPhone(phone)}
                        type='tel'
                        mask
                        error={errors.phone}
                        textError="Insira um número válido"
                        register={{ ...register("phone", { pattern: Regex.phone }) }} />
                    <Box sx={{ 'button': { width: '100%', height: '2.5rem', display: { xs: 'flex', md: 'none' } } }}>
                        <ButtonRectangle type="submit" name="REGISTRAR AUTORIZAÇÃO" loadingBtn={isLoading} disabled={disabledBtn} />
                    </Box>
                </Box>


                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Typography fontSize='1rem' color='white' fontWeight={700} padding='9px 2.125rem 4px' sx={{ backgroundColor: 'primary.light', width: 'fit-content', marginBottom: '5px' }}>
                        ATENÇÃO!
                    </Typography>
                    <Typography fontSize='1rem' lineHeight='19px' textAlign='center' sx={{ maxWidth: '35.93rem', border: '1.4px solid #17A7E0', borderRadius: '5px', padding: { xs: '.875rem 4px', md: '.875rem 1.6rem' } }}>
                        A indicação de um novo titular, <b>não desativa</b> o serviço do veículo atual.
                        Caso tenha interesse na sua desativação, entre em contato com nossa Central de Atendimento.
                    </Typography>
                </Box>
            </Box>

            <Modals open={showModal}>
                <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '23rem' } }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 1.31rem 1.25rem'>
                        {dataCreateChangeSolicitation === false ?
                            <>
                                <Typography fontSize='1.5625rem' fontWeight={700}>
                                    Central de Atendimento
                                </Typography>
                                <Typography fontSize='.875rem' lineHeight='17px' paddingTop='1rem'>
                                    Fale conosco através dos números abaixo:
                                </Typography>
                            </>
                            :
                            <>
                                <Typography fontSize='1.5625rem' fontWeight={700} textAlign='center'>
                                    SOLICITAÇÃO ENVIADA!
                                </Typography>
                                <Typography fontSize='1rem' lineHeight={1.3} paddingTop='.81rem' textAlign='center'>
                                    Entre em contato com a nossa <br />
                                    equipe através do número <br />
                                    de WhatsApp abaixo. <br />
                                </Typography>
                                <Typography fontSize='1rem' lineHeight={1.3} paddingTop='.3rem' textAlign='center'>
                                    Estamos prontos para <b>atendê-lo!</b>
                                </Typography>
                            </>
                        }

                    </Box>

                    <Box sx={{
                        borderRadius: '0 0 8px 8px',
                        padding: '1.25rem 3.81rem 2rem',
                        backgroundColor: 'primary.main',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                        }
                    }}>
                        {dataCreateChangeSolicitation === false ?
                            <>
                                <Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography fontSize='.75rem' color='white' paddingBottom='.2rem'>
                                            São Paulo
                                        </Typography>
                                        <Typography fontSize='.75rem' color='white' paddingBottom='.2rem'>
                                            Digite a opção 1,2
                                        </Typography>
                                    </Box>
                                    <LinkExtermal href="tel:1136169000">
                                        (011) 3616-9000
                                        <LocalPhoneOutlinedIcon />
                                    </LinkExtermal>
                                </Box>
                                <Box>
                                    <Typography fontSize='.75rem' color='white' paddingBottom='.2rem' textAlign='start'>
                                        Outras localidades
                                    </Typography>
                                    <LinkExtermal href="tel:08007742000">
                                        0800 774 2000
                                        <LocalPhoneOutlinedIcon />
                                    </LinkExtermal>
                                </Box>
                                <ButtonRectangle name='FECHAR' onClick={() => setShowModal(false)} />
                            </>
                            :
                            <Box>
                                <Typography fontSize='.80rem' color='white' paddingBottom='.2rem' textAlign='center'>
                                    Opção: <b>Trocas</b> <br />                    
                                </Typography>

                                <Typography fontSize='.92rem' color='white' paddingBottom='.2rem' textAlign='center'>
                                    Fale Conosco - <b>(11) 3616-9000</b>
                                </Typography>
                                
                                <Box sx={{
                                    'button': {
                                        marginTop: '1rem',
                                        borderColor: 'white',
                                        color: 'white',
                                        '&:hover': {
                                            borderColor: 'white',
                                            opacity: '.8'
                                        }
                                    }
                                }}>
                                    <ButtonOutlined name='FINALIZAR' onClick={() => { setShowModal(false); navigate(`${isWebView ? '/wb' : ''}/central-de-trocas`); }} />
                                </Box>
                            </Box>
                        }
                    </Box>
                </Box>
            </Modals>

            <Modals open={showModalExistActiveChanges}>
                <Box sx={{ borderRadius: '8px', textAlign: 'center', width: { xs: 'calc(100vw - 2rem)', md: '23.2rem' } }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 1rem 1.25rem'>
                        <Typography fontSize='1.5625rem' fontWeight={700} lineHeight='30px'>
                            ATENÇÃO!
                        </Typography>
                        <Typography fontSize='1rem' lineHeight='20px' marginTop='.5rem'>
                            Identificamos que você já possui uma solicitação de troca de titularidade em <b>andamento</b>, ao prosseguir com a nova solicitação, a anterior será <b>cancelada.</b>
                        </Typography>
                    </Box>
                    <Box sx={{ backgroundColor: 'primary.main', borderRadius: '0 0 8px 8px', padding: { xs: '1rem 2.5rem 1.625rem', md: '1rem 3.8125rem 1.625rem' }, 'button': { width: '100%' } }}>
                        <ButtonRectangle
                            name='CONTINUAR'
                            onClick={() => handleContinueWithActiveOccurrence()}
                        />
                        <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                            <ButtonOutlined
                                name='VER TROCAS'
                                onClick={() => { setShowModalExistActiveChanges(false); navigate(`${isWebView ? '/wb' : ''}/central-de-trocas/trocas-em-andamento`); }}
                            />
                        </Box>
                    </Box>
                </Box>
            </Modals>
        </ParseWebView >
    );
}

export default ChangeOfOwnership;